import React from 'react';
import { useHistory } from 'react-router-dom';
import authService from '../../services/authService';
import Icon from '../common/Icon';
import { getBrandConfig } from '../../utils/branding';
import './HeaderJvweb.css';

const HeaderJvweb = () => {
    const user = authService.getUser();
    const history = useHistory();
    const brand = getBrandConfig();

    const handleLogout = () => {
        authService.logout();
    };

    return (
        <header className="header-jvweb">
            <div className="header-jvweb-content">
                <div className="header-jvweb-logo">
                    {brand.isJvweb && brand.logoPath ? (
                        <img src={brand.logoPath} alt={brand.name} className="header-jvweb-logo-img" />
                    ) : (
                        <h1 className="header-jvweb-title">{brand.name}</h1>
                    )}
                </div>
                <div className="header-jvweb-actions">
                    {user && (
                        <>
                            <div className="header-jvweb-user-info">
                                <span className="header-jvweb-user-name">{user.name}</span>
                                <span className={`header-jvweb-user-role ${user.role?.toLowerCase()}`}>
                                    {user.role === 'SuperAdmin' ? 'SuperAdmin' :
                                     user.role === 'Admin' ? 'Admin' :
                                     'Utilisateur'}
                                </span>
                            </div>
                            {(user.role === 'Admin' || user.role === 'SuperAdmin') && (
                                <button
                                    onClick={() => history.push('/admin/users')}
                                    className="header-jvweb-button"
                                    aria-label="Administration"
                                    title="Gestion des utilisateurs"
                                >
                                    <Icon name="Settings" size={20} color="var(--color-gray-600)" />
                                </button>
                            )}
                            <button
                                onClick={handleLogout}
                                className="header-jvweb-button header-jvweb-logout"
                                aria-label="Déconnexion"
                                title="Déconnexion"
                            >
                                <Icon name="LogOut" size={20} color="var(--color-gray-600)" />
                            </button>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
};

export default HeaderJvweb;
